import {RadioGroup,Drawer,Image,OptionGroup,Carousel,CarouselItem,Progress,Pagination,Skeleton,SkeletonItem,TableColumn,Table,Timeline,TimelineItem,Tooltip,Tag,Autocomplete,TimePicker,CheckboxGroup,Popover,CheckboxButton,Checkbox,Row,Col,Form,FormItem,Dialog,Button,Collapse,CollapseItem,Input,Select,Option,DatePicker,Message,Loading,Tabs,TabPane,Cascader,Upload,MessageBox,TimeSelect,Radio,Steps,Step,InputNumber,Backtop} from 'element-ui'

import Vue from 'vue'

Vue.use(Button);
Vue.use(Dialog);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Skeleton);
Vue.use(SkeletonItem);
Vue.use(Image);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Cascader);
Vue.use(Upload);
Vue.use(TimeSelect);
Vue.use(Radio);
Vue.use(Steps);
Vue.use(Step);
Vue.use(InputNumber);
Vue.use(Backtop);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Row);
Vue.use(CheckboxGroup);
Vue.use(CheckboxButton);
Vue.use(Checkbox);
Vue.use(Popover)
Vue.use(Col);
Vue.use(TimePicker);
Vue.use(Autocomplete);
Vue.use(Tag);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Pagination);
Vue.use(Progress);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(OptionGroup);
Vue.use(Drawer);
Vue.use(RadioGroup);

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
